import { useState } from 'react';
import { toast } from 'react-toastify';

export const useUnsealModal = (onCompleteCallback) => {
    const [isUnsealModalOpen, setIsUnsealModalOpen] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState({ noTiket: null, namaIgt: null });

    const openUnsealModal = ({ noTiket, namaIgt }) => {
        setSelectedTicket({ noTiket, namaIgt });
        setIsUnsealModalOpen(true);
    };

    const closeUnsealModal = () => {
        setIsUnsealModalOpen(false);
        setSelectedTicket({ noTiket: null, namaIgt: null });
    };

    const handleUnsealComplete = () => {
        toast.success('File berhasil didekripsi dan diunduh!');
        closeUnsealModal();
        if (onCompleteCallback) {
            onCompleteCallback(); 
        }
    };

    return {
        isUnsealModalOpen,
        selectedTicket,
        openUnsealModal,
        closeUnsealModal,
        handleUnsealComplete
    };
};